export default (error) => {
  console.error('ERROR: ', error.message);
};
